import '../styles/experience.css'
import { useInView } from 'react-intersection-observer'

function Experience(props) {

  const [ref, inView]  = useInView
  ({threshold:0.2,
  });
  return (
      <section ref={ref} className="u-clearfix u-section-6" id="Experiencia">
      <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-0 u-layout-wrap u-layout-wrap-1">
        <div className="u-layout" >
          <div className="u-layout-row" >
            <div className="u-align-left u-container-align-center u-container-style u-image u-layout-cell u-left-cell u-size-30 u-size-xs-60 u-image-1" src="" data-image-width="961" data-image-height="905">
              <div className="u-container-layout u-valign-middle u-container-layout-1" src=""></div>
            </div>
            <div className="u-align-left u-container-style u-layout-cell u-palette-1-base u-right-cell u-size-30 u-size-xs-60 u-layout-cell-2">
              <div className="u-container-layout u-container-layout-2">
                <h3 className="u-align-right u-text u-text-default u-text-white u-text-1">{props.t("seccion6_1")}</h3>
                <p className="u-align-right u-text u-text-white u-text-2"> {props.t("seccion6_2")} <br/>
                {props.t("seccion6_3")} <br/>
                {props.t("seccion6_4")} <br/>
                {props.t("seccion6_5")} <br/>
                {props.t("seccion6_6")} <br/>
                {props.t("seccion6_7")}<br/>
                {props.t("seccion6_8")} <br/>
                {props.t("seccion6_9")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experience;